module.exports = __webpack_public_path__ + "img/icon_posos.fe27ae78.png";